// src/components/SuggestionBox.jsx
// Borang cadangan style / komen — hantar terus ke email via Web3Forms
// Email user diambil automatik dari akaun login
import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";

const WEB3FORMS_KEY = "82b3cc0a-698b-4022-96b7-4cdeec2baa0b";

export default function SuggestionBox({ user }) {
  const { t } = useLanguage();
  const [message, setMessage] = useState("");
  const [status, setStatus]   = useState("idle"); // idle | sending | success | error

  const handleSubmit = async () => {
    if (!message.trim()) return;
    if (!user) return;
    setStatus("sending");

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          subject: "New Promptix Style Suggestion",
          from_name: user.displayName || "Promptix User",
          message,
          user_email: user.email,
          user_name: user.displayName || "Anonymous",
        }),
      });

      const data = await res.json();
      if (data.success) {
        setStatus("success");
        setMessage("");
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div style={{ marginTop: 32, padding: "32px", background: "#13131a", borderRadius: 20, border: "1px solid #1e1e2e" }}>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>💡</div>
        <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 20, fontWeight: 700, marginBottom: 6 }}>
          {t("suggest_title")}
        </h2>
        <p style={{ color: "#666", fontSize: 13 }}>
          {t("suggest_desc")}
        </p>
      </div>

      {status === "success" ? (
        <div style={{ textAlign: "center", padding: "24px", color: "#10b981", fontSize: 14, fontWeight: 600 }}>
          {t("suggest_success")}
        </div>
      ) : !user ? (
        <div style={{ textAlign: "center", padding: "16px", color: "#666", fontSize: 13 }}>
          {t("suggest_login")}
        </div>
      ) : (
        <div style={{ maxWidth: 480, margin: "0 auto", display: "flex", flexDirection: "column", gap: 12 }}>
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder={t("suggest_placeholder")}
            rows={3}
            style={{ width: "100%", padding: "12px 14px", background: "#0c0c0f", border: "1px solid #2a2a3a", borderRadius: 12, color: "#e8e8f0", fontSize: 14, outline: "none", fontFamily: "inherit", resize: "vertical" }}
          />
          <button
            onClick={handleSubmit}
            disabled={status === "sending" || !message.trim()}
            style={{ width: "100%", padding: "13px", background: status === "sending" || !message.trim() ? "#2a2a3a" : "linear-gradient(135deg, #6366f1, #a855f7)", border: "none", borderRadius: 12, color: "#fff", fontSize: 14, fontWeight: 700, cursor: status === "sending" || !message.trim() ? "default" : "pointer", fontFamily: "inherit" }}
          >
            {status === "sending" ? t("suggest_sending") : t("suggest_send")}
          </button>
          {status === "error" && (
            <p style={{ textAlign: "center", fontSize: 12, color: "#ef4444" }}>
              {t("suggest_error")}
            </p>
          )}
        </div>
      )}
    </div>
  );
}